import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

export default function DiametrosSelection({
  label, diametros, diametro, disabled, hide, setSelecccionDiametroLente,
}) {
  const drawOptions = diametros => diametros.map(({ valor, valor_pedido }) => (
    <Select.Option key={valor_pedido || valor} value={valor_pedido || valor}>{valor_pedido || valor}</Select.Option>
  ));
  const selectMaskStyle = disabled ? { height: 'inherit' } : { backgroundColor: 'white', height: 'inherit' };
  const options = drawOptions(diametros);
  return (!hide
    && (
    <div style={{ marginLeft: '8px', height: '22px' }}>
      {label && <span className={`ant-input-group-addon ${disabled ? 'ant-select-disabled' : ''}`} style={{ width: 24, height: 'inherit' }}>{label}</span>}
      {label && <span className="ant-input-group-addon" style={{ padding: 0, borderLeft: 0, height: 'inherit' }} /> }
      {!label && <span className="ant-input-group-addon" style={{ padding: 0, height: 'inherit' }} /> }
      <span className="ant-input-group-addon" style={selectMaskStyle}>
        <Select
          size="small"
          value={diametro ? diametro.valor_pedido || diametro.valor : null}
          style={{ width: 80, borderColor: 'transparent' }}
          disabled={disabled}
          onChange={diametro => setSelecccionDiametroLente(diametros.find(e=>e.valor_pedido === diametro || e.valor === diametro))}
          loading={!diametro}
        >
          {options}
        </Select>
      </span>
    </div>
    )
  );
}

DiametrosSelection.propTypes = {
  label: PropTypes.string,
  setSelecccionDiametroLente: PropTypes.func,
  diametro: PropTypes.number.isRequired,
  diametros: PropTypes.arrayOf(PropTypes.number).isRequired,
  disabled: PropTypes.bool,
  hide: PropTypes.bool,
};

DiametrosSelection.defaultProps = {
  setSelecccionDiametroLente: () => {},
  disabled: false,
  hide: false,
  label: null,
};
